import {ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgxNotifications} from '@ngx-notifications/notifications.service';
import {NgxModal} from '@ngx-component-kit/cards/modal/modal.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '@core/services/auth.service';
import {ActivatedRoute} from '@angular/router';
import {Constants} from '@app/app.constants';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-admin-auth-password-request',
    templateUrl: './password-request.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordRequestComponent implements OnInit {

    // View children.
    @ViewChild(NgxModal, { static: true }) modal: NgxModal;
    @ViewChild('email', { static: true }) emailTextField: ElementRef;

    // Form.
    form: FormGroup;

    // States.
    isLoading = new BehaviorSubject(false);

    constructor(private _auth: AuthService,
                private _route: ActivatedRoute,
                private _notifications: NgxNotifications) {
    }

    get email() {
        return this.form.get('email');
    }

    private focusTextField = (element: ElementRef) => {
        if (!element.nativeElement) {
            return;
        }

        element.nativeElement.focus();
    };

    ngOnInit() {
        // Get the validators.
        const required = Validators.required;
        const email = Validators.pattern(Constants.regex.email);

        // Build the form.
        this.form = new FormGroup({
            email: new FormControl('', [required, email])
        });
    }

    async tryToRequestPassword() {
        // Set the button to display a loading state.
        this.isLoading.next(true);

        // Try to send a reset mail to the user.
        // When it fails reset the form email and show an error.
        try {
            // Get the platform id.
            const platform = this._route.snapshot.data.platform;
            const platformId = platform ? platform.id : null;

            // Do the request.
            await this._auth.request(this.email.value, platformId);
            this.modal.quit();
        } catch (error) {
            this.onError();
        }
    }

    private onError() {
        // Reset the loading button.
        this.isLoading.next(false);

        // Reset the email value and focus the element.
        this.email.setValue('');
        this.focusTextField(this.emailTextField);

        // Show an error notification.
        this._notifications.error('The email address is not recognized.');
    }

}
